const InputAdornment = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.action.disabled,
    }),
  },
};

export default InputAdornment;
